import styled from 'styled-components';
import COLORS from '../../../../../common/styles/color-pallete';
import DEVICES from '../../../../../common/styles/devices';
import { FONT_FAMILY } from '../../../../../common/styles/fontStyles';

export const RFIUploadHeaderContainer = styled.div`
  text-align: left;
  margin-top: 48px;
  @media ${DEVICES.mobileXL} {
    margin-left: 5px;
  }
`;
export const RFIUploadHeader = styled.div`
  font-size: 18px;
  line-height: 26px;
  font-family: ${FONT_FAMILY.hellix.bold};
  text-align: left;
`;

export const RFIUploadSubHeader = styled.div`
  margin-top: 12px;
  font-size: 16px;
  line-height: 22px;
  font-family: ${FONT_FAMILY.hellix.regular};
  color: ${COLORS.textGrey};
`;

export const SubContainer = styled.div`
  width: 450px;
  display: flex;
  flex-direction: column;
  margin-top: -35px;
  color: ${COLORS.black};

  @media (max-width: 900px) {
    margin-top: 15px;
  }

  @media ${DEVICES.mobileXL} {
    width: 95%;
    margin-top: 35px;
    padding: 0 16px;
  }
`;

export const Header = styled.div`
  font-size: 28px;
  line-height: 38px;
  font-weight: 700;
  font-family: ${FONT_FAMILY.hellix.bold};
`;

export const SubHeader = styled.div`
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  color: ${COLORS.textGrey};
  margin-top: 8px;
  font-family: ${FONT_FAMILY.hellix.regular};
`;

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;

  .radioButtonContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
  }

  .radioButtonWrapper {
    display: flex;
    align-items: center;
    color: ${COLORS.black};
  }

  input[type='radio'] {
    width: 24px;
    height: 24px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 50%;
    border: 2px solid ${COLORS.textLightGrey};
    outline: none;
    cursor: pointer;
    position: relative;
  }

  /* Unchecked radio button */
  input[type='radio']:not(:checked) {
    border-color: ${COLORS.textLightGrey};
  }

  /* Checked radio button */
  input[type='radio']:checked {
    border-color: ${COLORS.brandPrimary};
  }

  /* Checked radio button dot */
  input[type='radio']:checked::before {
    content: '';
    position: absolute;
    top: 3px;
    left: 3px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: ${COLORS.brandPrimary};
  }

  .selectedFieldContent {
    margin-top: 23px;
  }
`;

type FileUploadTextContainerProps = {
  fontWeight?: number;
  textColor?: string;
  descriptionColor?: string;
  cursor?: boolean;
  headerMarginTop?: number;
  isPOAFlow?: boolean;
};

export const FileUploadTextContainer = styled.div<FileUploadTextContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  .__heading {
    font-size: 14px;
    font-weight: ${({ fontWeight }) => fontWeight! | 700};
    margin-top: ${(props) => props.headerMarginTop! | 0}px;
    margin-bottom: 5px;
    color: ${({ textColor }) => textColor};
    cursor: ${({ cursor }) => (cursor ? 'pointer' : 'inherit')};
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .__description {
    margin-top: ${({ isPOAFlow }) => (isPOAFlow ? '0' : '24px')};
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    color: ${({ descriptionColor }) => descriptionColor || `${COLORS.textLightGrey}`};
    white-space: pre-wrap;
  }
  .__subDescription {
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    color: ${({ descriptionColor }) => descriptionColor || `${COLORS.textLightGrey}`};
    white-space: pre-wrap;
  }
`;
export const Text = styled.div`
  font-size: 16px;
  line-height: 26px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.textGrey};
`;
export const SubText = styled.div`
  font-size: 16px;
  line-height: 22px;
  font-family: ${FONT_FAMILY.hellix.regular};
  color: ${COLORS.textLightGrey};
`;
export const TextWrapper = styled.div`
  margin-top: 48px;
`;
